import {selectTaskManagement} from '../selectors'

export const getExportState = (state) => selectTaskManagement(state).exportCsvTaskList


// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/selectors.js